import React from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import Shared100toGPA from './Shared100toGPA';
import SharedGPAto100 from './SharedGPAto100';
const TITLE = 'Convert Cumulative GPA to Percentage and Vice Versa - Convert GPA from 4 to 100';
const DESCRIPTION = "Calculate and convert your cumulative GPA between the 4-point and 100-point systems easily. Learn how to convert the cumulative GPA from 4 to 100 and vice versa using this simple tool.";
const KEYWORDS = "Convert Cumulative GPA, Convert from 4 to 100, University GPA Conversion, Convert University GPA from 4 to 100, Convert University GPA to Percentage";
const OG_URL = 'https://do-calculate.com/calculator/en/grade100to4';
function Grade100to4() {
  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
              <div className="border border-light">
                <div className="row">
                  <div>
                    <p>
                      {DESCRIPTION}
                    </p>
                    <hr />
                  </div>
                  <br />
                </div>
                 <MobileUnderCalAds/>
                <div className="row">
                  <div className="col">
                    <Shared100toGPA />
                  </div>
                </div>
                <div>
                  <br />
                </div>
                <hr />
                <div className="row">
                  <div className="col">
                    <SharedGPAto100 />
                  </div>
                </div>
                <div>
                  <br />
                </div>
                <hr />
                <div className="row">
                  <RelatedLinks />
                  <hr />
                </div>
              </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.studyCalculators}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Grade Conversion Table - Convert GPA from 4 to 100</h2></u>
                  <table >
                    <tbody>
                    <tr className='gpa-header'>
                      <th>Grade</th>
                      <th>Percentage</th>
                      <th>GPA</th>
                    </tr>
                    <tr>
                      <td>A+</td>
                      <td>97-100</td>
                      <td>4.0</td>
                    </tr>
                    <tr>
                      <td>A</td>
                      <td>93-96</td>
                      <td>4.0</td>
                    </tr>
                    <tr>
                      <td>A-</td>
                      <td>90-92</td>
                      <td>3.7</td>
                    </tr>
                    <tr>
                      <td>B+</td>
                      <td>87-89</td>
                      <td>3.3</td>
                    </tr>
                    <tr>
                      <td>B</td>
                      <td>83-86</td>
                      <td>3.0</td>
                    </tr>
                    <tr>
                      <td>B-</td>
                      <td>80-82</td>
                      <td>2.7</td>
                    </tr>
                    <tr>
                      <td>C+</td>
                      <td>77-79</td>
                      <td>2.3</td>
                    </tr>
                    <tr>
                      <td>C</td>
                      <td>73-76</td>
                      <td>2.0</td>
                    </tr>
                    <tr>
                      <td>C-</td>
                      <td>70-72</td>
                      <td>1.7</td>
                    </tr>
                    <tr>
                      <td>D+</td>
                      <td>67-69</td>
                      <td>1.3</td>
                    </tr>
                    <tr>
                      <td>D</td>
                      <td>65-66</td>
                      <td>1.0</td>
                    </tr>
                    <tr>
                      <td>E/F</td>
                      <td>Less than 65</td>
                      <td>0.0</td>
                    </tr>
                    </tbody>
                  </table>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Grade100to4;
